const GOOGLE_NEWS_APP_MARKER = 'GNews';

const isFromGoogleNews = window.navigator.userAgent.includes(GOOGLE_NEWS_APP_MARKER);

export {
  isFromGoogleNews
};
